export default __webpack_public_path__ + "static/media/muñecas de barro masaya2.12591643.jpg";